// STORY-022: remember the AI Scanner bar dismissal in a cookie (one-month expiry).

const AI_SCANNER_BAR_DISMISSED_COOKIE = 'aiScanner.bar.dismissed';
const ONE_MONTH_MS = 86400 * 1000 * 30;

const getCookieDomain = () => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost') {
    return hostname;
  }
  const tokens = hostname.split('.');
  tokens.shift();
  return tokens.join('.');
};

export const dismissAiScannerBar = () => {
  const expires = new Date(Date.now() + ONE_MONTH_MS).toUTCString();
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie =
    AI_SCANNER_BAR_DISMISSED_COOKIE +
    '=1; domain=' +
    getCookieDomain() +
    '; expires=' +
    expires +
    '; path=/; SameSite=Lax' +
    secure;
};

export const isAiScannerBarDismissed = () =>
  document.cookie
    .split('; ')
    .some((row) => row.startsWith(AI_SCANNER_BAR_DISMISSED_COOKIE + '='));
